









































































































































































































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Timeline extends Vue {
    freeTrialTermTitleImage =
        'https://usermodel-assets.s3.ap-northeast-1.amazonaws.com/musio-english-assets/freetrialterm_title%402x.png'
    timelineTitleImage =
        'https://usermodel-assets.s3.ap-northeast-1.amazonaws.com/musio-english-assets/timeline_title%402x.png'
    timelineImage =
        'https://usermodel-assets.s3.ap-northeast-1.amazonaws.com/musio-english-assets/timeline7days.png'
}
